(function () {
  'use strict';

  /* ---------- DOM ---------- */
  var drawer = document.querySelector('[data-reserve-drawer]');
  if (!drawer) return;

  var overlay = drawer.querySelector('[data-reserve-overlay]');
  var panel = drawer.querySelector('[data-reserve-panel]');
  var backBtn = drawer.querySelector('[data-reserve-back]');
  var closeBtn = drawer.querySelector('[data-reserve-close]');
  var stepIndicators = drawer.querySelectorAll('[data-reserve-step]');
  var stepBodies = drawer.querySelectorAll('[data-reserve-step-body]');
  var productImg = drawer.querySelector('[data-reserve-product-img]');
  var productName = drawer.querySelector('[data-reserve-product-name]');
  var productPrice = drawer.querySelector('[data-reserve-product-price]');
  var productSummary = drawer.querySelector('[data-reserve-product]');
  var searchInput = drawer.querySelector('[data-reserve-search]');
  var storeList = drawer.querySelector('[data-reserve-stores]');
  var noResults = drawer.querySelector('[data-reserve-no-results]');
  var selectedStoreName = drawer.querySelector('[data-reserve-selected-store-name]');
  var selectedStoreAddr = drawer.querySelector('[data-reserve-selected-store-address]');
  var formErrors = drawer.querySelector('[data-reserve-form-errors]');
  var submitBtn = drawer.querySelector('[data-reserve-submit]');
  var hiddenForm = document.getElementById('reserve-contact-form');

  /* ---------- Scroll lock ---------- */
  var prevBodyOverflow = '';

  /* ---------- State ---------- */
  var state = {
    step: 1,
    product: null,
    store: null,
    customer: null
  };

  /* ---------- Store data from section blocks ---------- */
  var stores = [];
  var storeDataEl = document.getElementById('reserve-store-data');
  if (storeDataEl) {
    try { stores = JSON.parse(storeDataEl.textContent); } catch (e) { stores = []; }
  }

  /* ---------- Reserve page redirect ---------- */
  var reservePageUrl = drawer.dataset.reservePageUrl || '';

  /* ---------- Open / Close ---------- */
  window.openReserveDrawer = function (productData) {
    /* If a reserve page is configured, navigate there instead of opening the drawer */
    if (reservePageUrl) {
      var url = reservePageUrl + '?handle=' + encodeURIComponent(productData.handle || '');
      if (productData.variantId) url += '&variant=' + encodeURIComponent(productData.variantId);
      window.location.href = url;
      return;
    }
    state.product = productData;
    state.store = null;
    state.customer = null;
    state.step = 1;

    // Populate product summary
    if (productImg) {
      productImg.src = productData.image || '';
      productImg.alt = productData.title || '';
    }
    if (productName) productName.textContent = productData.title || '';
    if (productPrice) productPrice.textContent = productData.price || '';

    // Reset form
    resetForm();

    // Show step 1
    goToStep(1);

    // Open drawer
    drawer.classList.add('is-open');
    prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // Render stores
    renderStores(stores);

    // Focus search input after transition
    if (searchInput) {
      setTimeout(function () { searchInput.focus(); }, 350);
    }
  };

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = prevBodyOverflow;

    setTimeout(function () {
      state.step = 1;
      state.product = null;
      state.store = null;
      state.customer = null;
      resetForm();
      if (searchInput) searchInput.value = '';
      renderStores(stores);
      goToStep(1);
    }, 300);
  }

  /* ---------- Navigation ---------- */
  function goToStep(n) {
    state.step = n;

    // Update step indicators
    stepIndicators.forEach(function (el) {
      var s = parseInt(el.dataset.reserveStep, 10);
      el.classList.remove('is-active', 'is-completed');
      if (s === n) el.classList.add('is-active');
      else if (s < n) el.classList.add('is-completed');
    });

    // Toggle step bodies
    stepBodies.forEach(function (el) {
      var s = parseInt(el.dataset.reserveStepBody, 10);
      el.classList.toggle('is-active', s === n);
    });

    // Back button visibility
    if (backBtn) {
      backBtn.classList.toggle('is-visible', n === 2);
    }

    // Product summary visibility (show on steps 1 & 2)
    if (productSummary) {
      productSummary.style.display = (n <= 2) ? '' : 'none';
    }
  }

  /* ---------- Store rendering ---------- */
  function renderStores(filtered) {
    if (!storeList) return;

    storeList.innerHTML = '';

    if (filtered.length === 0) {
      if (noResults) noResults.style.display = 'block';
      return;
    }

    if (noResults) noResults.style.display = 'none';

    filtered.forEach(function (store) {
      var card = document.createElement('div');
      card.className = 'reserve-drawer__store-card';

      var nameEl = document.createElement('div');
      nameEl.className = 'reserve-drawer__store-name';
      nameEl.textContent = store.name;
      card.appendChild(nameEl);

      var addrEl = document.createElement('div');
      addrEl.className = 'reserve-drawer__store-address';
      addrEl.textContent = store.address;
      if (store.city || store.postal_code) {
        addrEl.textContent += '\n' + [store.city, store.postal_code].filter(Boolean).join(', ');
      }
      addrEl.style.whiteSpace = 'pre-line';
      card.appendChild(addrEl);

      if (store.phone || store.hours) {
        var detailEl = document.createElement('div');
        detailEl.className = 'reserve-drawer__store-detail';
        var parts = [];
        if (store.phone) parts.push(store.phone);
        if (store.hours) parts.push(store.hours);
        detailEl.textContent = parts.join('  •  ');
        card.appendChild(detailEl);
      }

      card.addEventListener('click', function () {
        state.store = store;
        if (selectedStoreName) selectedStoreName.textContent = store.name;
        if (selectedStoreAddr) {
          var addr = store.address;
          if (store.city || store.postal_code) {
            addr += ', ' + [store.city, store.postal_code].filter(Boolean).join(' ');
          }
          selectedStoreAddr.textContent = addr;
        }
        goToStep(2);
      });

      storeList.appendChild(card);
    });
  }

  /* ---------- Search / filter ---------- */
  var searchTimeout;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(function () {
        var q = searchInput.value.trim().toLowerCase();
        if (!q) {
          renderStores(stores);
          return;
        }
        var filtered = stores.filter(function (s) {
          return (
            (s.name && s.name.toLowerCase().indexOf(q) > -1) ||
            (s.city && s.city.toLowerCase().indexOf(q) > -1) ||
            (s.postal_code && s.postal_code.toLowerCase().indexOf(q) > -1) ||
            (s.address && s.address.toLowerCase().indexOf(q) > -1)
          );
        });
        renderStores(filtered);
      }, 250);
    });
  }

  /* ---------- Form validation ---------- */
  function validateForm() {
    var nameVal = drawer.querySelector('[data-reserve-field="name"]');
    var emailVal = drawer.querySelector('[data-reserve-field="email"]');
    var phoneVal = drawer.querySelector('[data-reserve-field="phone"]');
    var privacyVal = drawer.querySelector('[data-reserve-field="privacy"]');

    var errors = [];

    // Clear previous error states
    drawer.querySelectorAll('.is-error').forEach(function (el) {
      el.classList.remove('is-error');
    });
    drawer.querySelectorAll('.reserve-drawer__error').forEach(function (el) {
      el.classList.remove('is-visible');
    });

    if (!nameVal || !nameVal.value.trim()) {
      errors.push('Name is required');
      if (nameVal) nameVal.classList.add('is-error');
    }

    if (!emailVal || !emailVal.value.trim()) {
      errors.push('Email is required');
      if (emailVal) emailVal.classList.add('is-error');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal.value.trim())) {
      errors.push('Please enter a valid email address');
      if (emailVal) emailVal.classList.add('is-error');
    }

    if (!phoneVal || !phoneVal.value.trim()) {
      errors.push('Phone number is required');
      if (phoneVal) phoneVal.classList.add('is-error');
    }

    if (!privacyVal || !privacyVal.checked) {
      errors.push('You must agree to the privacy policy');
    }

    if (errors.length > 0 && formErrors) {
      formErrors.textContent = errors.join('. ') + '.';
      formErrors.classList.add('is-visible');
    }

    return errors.length === 0;
  }

  /* ---------- Form reset ---------- */
  function resetForm() {
    var fields = drawer.querySelectorAll('[data-reserve-field]');
    fields.forEach(function (el) {
      if (el.type === 'checkbox') {
        el.checked = false;
      } else {
        el.value = '';
      }
      el.classList.remove('is-error');
    });
    drawer.querySelectorAll('.reserve-drawer__error').forEach(function (el) {
      el.classList.remove('is-visible');
    });
    if (formErrors) formErrors.classList.remove('is-visible');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'SUBMIT RESERVATION';
    }
  }

  /* ---------- Form submission ---------- */
  function submitReservation() {
    if (!validateForm()) return;

    var nameVal = drawer.querySelector('[data-reserve-field="name"]').value.trim();
    var emailVal = drawer.querySelector('[data-reserve-field="email"]').value.trim();
    var phoneVal = drawer.querySelector('[data-reserve-field="phone"]').value.trim();
    var commentVal = (drawer.querySelector('[data-reserve-field="comment"]') || {}).value || '';

    state.customer = {
      name: nameVal,
      email: emailVal,
      phone: phoneVal,
      comment: commentVal.trim()
    };

    // Build reservation data
    var reservationData = {
      product: {
        id: state.product.id,
        variantId: state.product.variantId,
        title: state.product.title,
        price: state.product.price,
        handle: state.product.handle
      },
      store: {
        name: state.store.name,
        address: state.store.address,
        city: state.store.city,
        postal_code: state.store.postal_code,
        phone: state.store.phone,
        email: state.store.email
      },
      customer: state.customer,
      timestamp: new Date().toISOString()
    };

    // Populate hidden form
    if (hiddenForm) {
      var setField = function (name, value) {
        var input = hiddenForm.querySelector('[name="' + name + '"]');
        if (input) input.value = value;
      };

      setField('contact[email]', emailVal);
      setField('contact[first_name]', nameVal);
      setField('contact[phone]', phoneVal);
      setField('contact[body]', JSON.stringify(reservationData));
    }

    // Disable submit
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'SUBMITTING...';
    }

    // Submit via AJAX — use redirect:'manual' so Shopify's 302 becomes
    // an opaque redirect response instead of a followed navigation.
    var formData = new FormData(hiddenForm);

    fetch(hiddenForm.action, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      },
      redirect: 'manual'
    })
      .then(function (response) {
        if (response.type === 'opaqueredirect' || response.ok || response.status === 302) {
          onSubmitSuccess(reservationData);
        } else {
          onSubmitError();
        }
      })
      .catch(function () {
        onSubmitError();
      });
  }

  function onSubmitSuccess(data) {
    // Populate confirmation recap
    var recapProduct = drawer.querySelector('[data-reserve-recap-product]');
    var recapStore = drawer.querySelector('[data-reserve-recap-store]');
    var recapName = drawer.querySelector('[data-reserve-recap-name]');
    var recapEmail = drawer.querySelector('[data-reserve-recap-email]');
    var recapPhone = drawer.querySelector('[data-reserve-recap-phone]');

    if (recapProduct) recapProduct.textContent = data.product.title;
    if (recapStore) recapStore.textContent = data.store.name;
    if (recapName) recapName.textContent = data.customer.name;
    if (recapEmail) recapEmail.textContent = data.customer.email;
    if (recapPhone) recapPhone.textContent = data.customer.phone;

    goToStep(3);

    // Analytics
    try {
      document.dispatchEvent(new CustomEvent('reservation:completed', { detail: data }));
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'reservation_completed',
          reservation: data
        });
      }
    } catch (e) { /* analytics should not break flow */ }
  }

  function onSubmitError() {
    if (formErrors) {
      formErrors.textContent = 'Something went wrong. Please try again.';
      formErrors.classList.add('is-visible');
    }
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'SUBMIT RESERVATION';
    }
  }

  /* ---------- Event listeners ---------- */
  if (panel) panel.addEventListener('click', function (e) { e.stopPropagation(); });
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (state.step === 2) goToStep(1);
    });
  }
  if (submitBtn) submitBtn.addEventListener('click', submitReservation);

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Continue shopping button
  var continueBtn = drawer.querySelector('[data-reserve-continue]');
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);
})();
